export default "__VITE_ASSET__nT67T2hm__"